// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".markdown_pkxfA p{line-height:25.6px;margin-bottom:1.5rem}.markdown_pkxfA p:last-of-type{margin-bottom:0}@media (min-width:768px){.markdown_pkxfA p{margin-bottom:2rem}}.markdown_pkxfA p{font-feature-settings:\"ss10\" on,\"salt\" on,\"onum\" on}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"markdown": "markdown_pkxfA"
};
module.exports = ___CSS_LOADER_EXPORT___;
